import _ from 'lodash';
import Logger from '../util/Logger';

const getPostsSentimentNegative = (sentiment) => {
  if (!sentiment) {
    Logger.assert('Missing sentiment');
  } else {
    return _.get(sentiment, 'posts_sentiment_negative') || 0;
  }
};

const getPostsSentimentNeutral = (sentiment) => {
  if (!sentiment) {
    Logger.assert('Missing sentiment');
  } else {
    return _.get(sentiment, 'posts_sentiment_neutral') || 0;
  }
};

const getPostsSentimentPositive = (sentiment) => {
  if (!sentiment) {
    Logger.assert('Missing sentiment');
  } else {
    return _.get(sentiment, 'posts_sentiment_positive') || 0;
  }
};

const getTotal = (sentiment) => {
  if (!sentiment) {
    Logger.assert('Missing sentiment');
  } else {
    return (
      getPostsSentimentNegative(sentiment) +
      getPostsSentimentNeutral(sentiment) +
      getPostsSentimentPositive(sentiment)
    );
  }
};

export default {

  getNegativePercent (sentiment) {
    if (!sentiment) {
      Logger.assert('Missing sentiment');
    } else {
      const total = getTotal(sentiment);
      return total ? (getPostsSentimentNegative(sentiment) / total) * 100 : 0;
    }
  },

  getNeutralPercent (sentiment) {
    if (!sentiment) {
      Logger.assert('Missing sentiment');
    } else {
      const total = getTotal(sentiment);
      return total ? (getPostsSentimentNeutral(sentiment) / total) * 100 : 0;
    }
  },

  getPositivePercent (sentiment) {
    if (!sentiment) {
      Logger.assert('Missing sentiment');
    } else {
      const total = getTotal(sentiment);
      return total ? (getPostsSentimentPositive(sentiment) / total) * 100 : 0;
    }
  }

};
